module.exports = __webpack_public_path__ + "static/media/468x60_0056_en.27c912c7.gif";